import { bondCompounds, type BondCompound, type BondType } from "./compounds";

/**
 * Bond Type Snap - pure question-generation + scoring.
 *
 * Every question shows one compound and offers three buttons:
 * Ionic / Covalent / Metallic. Speed-bonus scoring matches the bundle.
 */

export const SNAP_TURN_SECONDS = 8;
export const SNAP_FAST_THRESHOLD_S = 3;
export const SNAP_POINTS_FAST = 15;
export const SNAP_POINTS_SLOW = 8;

export type SnapOutcome = "fast" | "slow" | "wrong" | "timeout";

export interface SnapQuestion {
  id: string;
  compound: BondCompound;
}

function pickRandom<T>(rng: () => number, arr: T[]): T {
  return arr[Math.floor(rng() * arr.length)];
}

export function generateQuestion(
  rng: () => number,
  excludeIds: ReadonlySet<string>,
): SnapQuestion {
  const available = bondCompounds.filter((c) => !excludeIds.has(c.id));
  const pool = available.length > 0 ? available : bondCompounds;
  const target = pickRandom(rng, pool);
  return { id: target.id, compound: target };
}

export function scoreAnswer(
  chosen: BondType | null,
  question: SnapQuestion,
  elapsedMs: number,
): { points: number; outcome: SnapOutcome } {
  if (chosen === null) return { points: 0, outcome: "timeout" };
  if (chosen !== question.compound.bond) return { points: 0, outcome: "wrong" };
  if (elapsedMs <= SNAP_FAST_THRESHOLD_S * 1000) {
    return { points: SNAP_POINTS_FAST, outcome: "fast" };
  }
  return { points: SNAP_POINTS_SLOW, outcome: "slow" };
}

export type { BondType, BondCompound };